export type RoleName = 'admin' | 'analyst' | 'readonly';

export const ROLE_OPTIONS = [
  { value: 'admin' as const, label: 'Admin' },
  { value: 'analyst' as const, label: 'Analyst' },
  { value: 'readonly' as const, label: 'Read Only' },
] as const;

export function formatRoleName(role?: string): string {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'analyst':
      return 'Analyst';
    case 'readonly':
      return 'Read Only';
    default:
      return 'Read Only';
  }
}

const ROLE_HIERARCHY: RoleName[] = ['admin', 'analyst', 'readonly'];

export function getFilteredRoleOptions(
  userRole?: string
): { value: RoleName; label: string }[] {
  const userIndex = ROLE_HIERARCHY.indexOf(userRole as RoleName);
  if (userIndex === -1) {
    // Unknown or missing role — safest default is readonly only
    return ROLE_OPTIONS.filter(opt => opt.value === 'readonly');
  }
  const allowedRoles = ROLE_HIERARCHY.slice(userIndex);
  return ROLE_OPTIONS.filter(opt => allowedRoles.includes(opt.value));
}

export function getRoleChipStyle(
  role?: string
): 'primary' | 'secondary' | 'default' {
  switch (role) {
    case 'admin':
      return 'primary';
    case 'analyst':
      return 'secondary';
    default:
      return 'default';
  }
}
